import React from 'react'
import "./Shimmer.css"
const Shimmer = () => {
  return (
    <div className='Shimmer'>
        {Array(15).fill("").map((e,idx)=>(
            <div key={idx} className="shimmerEle"></div>
        ))}
    </div>
  )
}

export default Shimmer